import { Injectable } from "@angular/core";
import * as moment from "moment";
import { TranslateService } from "@ngx-translate/core";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";

@Injectable({
  providedIn: "root",
})
export class DateService {
  constructor(
    private toastrAlertService: ToastrAlertService,
    private translateService: TranslateService
  ) {}

  validateDatesFromUntil(
    endDate: string,
    startDate: string,
    monthsDiffBetweenTwoDates: number
  ): boolean {
    let diff = moment(endDate).diff(moment(startDate), "months", true);
    if (diff > monthsDiffBetweenTwoDates) {
      let text = this.translateService.instant("messages.diffOfDates");
      this.toastrAlertService.toastrFail(text);
      return false;
    } else if (diff < monthsDiffBetweenTwoDates * -1) {
      let text = this.translateService.instant("messages.diffOfDates");
      this.toastrAlertService.toastrFail(text);
      return false;
    } else if (moment(startDate).isAfter(moment(endDate))) {
      let text = this.translateService.instant(
        "messages.dateEndIsAfterDateStart"
      );
      this.toastrAlertService.toastrFail(text);
      return false;
    }

    return true;
  }

  changeFormatDate(date: string, format: string): string {
    if (date) {
      return moment(date).format(format);
    } else {
      return null;
    }
  }
}
